import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import messages from './page-description-messages';
import styles from './page-description.module.less';
import HelpArticleLink from '../../../../../components/help-article-link';
import { linkIDs } from '../../../../../services/link-service/links';

const DefaultDescription = () => (
  <>
    <FormattedMessage {...messages.pageDescription} />
    <Tooltip position='right-top'>
      <div className={styles['header-tooltip']}>
        <FontAwesomeIcon className={styles['header-icon']} icon={faExclamationCircle} />
      </div>
      <TooltipContent>
        <FormattedMessage {...messages.tooltipContent} />
      </TooltipContent>
    </Tooltip>
  </>
);

const DescriptionWithDocumentation = () => (
  <FormattedMessage
    {...messages.vendorConnectPageDescription}
    values={{
      a: (chunks) => <HelpArticleLink articleId={linkIDs.FulfillmentProviders}>{chunks}</HelpArticleLink>,
    }}
  />
);

export const PageDescription = ({ shouldShowVendorTab }) => {
  const description = shouldShowVendorTab ? <DescriptionWithDocumentation /> : <DefaultDescription />;
  return <section className={styles['page-description']}> {description} </section>;
};
